import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { CabButtonComponent } from "../form/components/cab-button/cab-button.component";
import { WarningMassageComponent } from "@shared/datatable/actions/warning-massage/warning-massage.component";

@Component({
  selector: "app-confirm-modal",
  templateUrl: "./confirm-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CabButtonComponent, TranslateModule, WarningMassageComponent],
})
export class ConfirmModalComponent {
  @Input() modalTitle: string;
  @Input() message: string;
  @Input() confirmText = "BUTTON.DELETE"; //"CONFIRMATION.CONFIRM"
  @Input() cancelText = "CONFIRMATION.CANCEL";
  @Input() warningMessage: string;
  @Input() hasFooter: boolean = true;
  @Input() btnStyleType:
    | "success"
    | "primary"
    | "secondary"
    | "danger"
    | "light"
    | "dark" = "danger";

  constructor(public activeModal: NgbActiveModal) {}
}
